"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = exports.Checkbox = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.function.name.js");
var _react = _interopRequireWildcard(require("react"));
var _useObservabilitySafe = require("../../hooks/useObservabilitySafe");
var _theme = require("../../system/theme");
var _utils = require("../../system/utils");
var _index = require("../index");
var _Label = _interopRequireDefault(require("../Label"));
var _excluded = ["additionalContainerChildren", "analyticsName", "checked", "disabled", "errorMessage", "hasContainer", "label", "name", "subtitle", "type", "value", "onClick"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function cov_2ej087gpzc() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Input/CheckboxOrRadio.tsx";
  var hash = "dab72b5b3a5c5d4ef080aab4e75930f9173f8ae0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Input/CheckboxOrRadio.tsx",
    statementMap: {
      "0": {
        start: {
          line: 39,
          column: 56
        },
        end: {
          line: 173,
          column: 1
        }
      },
      "1": {
        start: {
          line: 54,
          column: 19
        },
        end: {
          line: 54,
          column: 31
        }
      },
      "2": {
        start: {
          line: 55,
          column: 21
        },
        end: {
          line: 55,
          column: 31
        }
      },
      "3": {
        start: {
          line: 56,
          column: 22
        },
        end: {
          line: 56,
          column: 49
        }
      },
      "4": {
        start: {
          line: 57,
          column: 25
        },
        end: {
          line: 57,
          column: 55
        }
      },
      "5": {
        start: {
          line: 58,
          column: 21
        },
        end: {
          line: 58,
          column: 60
        }
      },
      "6": {
        start: {
          line: 59,
          column: 26
        },
        end: {
          line: 65,
          column: 28
        }
      },
      "7": {
        start: {
          line: 66,
          column: 22
        },
        end: {
          line: 74,
          column: 7
        }
      },
      "8": {
        start: {
          line: 76,
          column: 32
        },
        end: {
          line: 76,
          column: 54
        }
      },
      "9": {
        start: {
          line: 78,
          column: 22
        },
        end: {
          line: 88,
          column: 3
        }
      },
      "10": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 79,
          column: 26
        }
      },
      "11": {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 87,
          column: 5
        }
      },
      "12": {
        start: {
          line: 81,
          column: 19
        },
        end: {
          line: 81,
          column: 67
        }
      },
      "13": {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 86,
          column: 8
        }
      },
      "14": {
        start: {
          line: 90,
          column: 2
        },
        end: {
          line: 172,
          column: 4
        }
      },
      "15": {
        start: {
          line: 101,
          column: 25
        },
        end: {
          line: 101,
          column: 52
        }
      },
      "16": {
        start: {
          line: 102,
          column: 14
        },
        end: {
          line: 113,
          column: 15
        }
      },
      "17": {
        start: {
          line: 112,
          column: 16
        },
        end: {
          line: 112,
          column: 46
        }
      },
      "18": {
        start: {
          line: 175,
          column: 70
        },
        end: {
          line: 177,
          column: 1
        }
      },
      "19": {
        start: {
          line: 176,
          column: 2
        },
        end: {
          line: 176,
          column: 56
        }
      },
      "20": {
        start: {
          line: 179,
          column: 67
        },
        end: {
          line: 181,
          column: 1
        }
      },
      "21": {
        start: {
          line: 180,
          column: 2
        },
        end: {
          line: 180,
          column: 53
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 39,
            column: 56
          },
          end: {
            line: 39,
            column: 57
          }
        },
        loc: {
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 173,
            column: 1
          }
        },
        line: 53
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 78,
            column: 22
          },
          end: {
            line: 78,
            column: 23
          }
        },
        loc: {
          start: {
            line: 78,
            column: 65
          },
          end: {
            line: 88,
            column: 3
          }
        },
        line: 78
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 100,
            column: 12
          },
          end: {
            line: 100,
            column: 13
          }
        },
        loc: {
          start: {
            line: 100,
            column: 41
          },
          end: {
            line: 114,
            column: 13
          }
        },
        line: 100
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 175,
            column: 70
          },
          end: {
            line: 175,
            column: 71
          }
        },
        loc: {
          start: {
            line: 175,
            column: 81
          },
          end: {
            line: 177,
            column: 1
          }
        },
        line: 175
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 179,
            column: 67
          },
          end: {
            line: 179,
            column: 68
          }
        },
        loc: {
          start: {
            line: 179,
            column: 78
          },
          end: {
            line: 181,
            column: 1
          }
        },
        line: 179
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 59,
            column: 26
          },
          end: {
            line: 65,
            column: 28
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 64,
            column: 31
          }
        }, {
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 65,
            column: 28
          }
        }],
        line: 59
      },
      "1": {
        loc: {
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 64,
            column: 31
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 61,
            column: 33
          }
        }, {
          start: {
            line: 62,
            column: 8
          },
          end: {
            line: 64,
            column: 31
          }
        }],
        line: 60
      },
      "2": {
        loc: {
          start: {
            line: 62,
            column: 8
          },
          end: {
            line: 64,
            column: 31
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 63,
            column: 36
          }
        }, {
          start: {
            line: 64,
            column: 8
          },
          end: {
            line: 64,
            column: 31
          }
        }],
        line: 62
      },
      "3": {
        loc: {
          start: {
            line: 66,
            column: 22
          },
          end: {
            line: 74,
            column: 7
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 67,
            column: 6
          },
          end: {
            line: 70,
            column: 7
          }
        }, {
          start: {
            line: 71,
            column: 6
          },
          end: {
            line: 74,
            column: 7
          }
        }],
        line: 66
      },
      "4": {
        loc: {
          start: {
            line: 68,
            column: 20
          },
          end: {
            line: 68,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 68,
            column: 35
          },
          end: {
            line: 68,
            column: 45
          }
        }, {
          start: {
            line: 68,
            column: 48
          },
          end: {
            line: 68,
            column: 56
          }
        }],
        line: 68
      },
      "5": {
        loc: {
          start: {
            line: 72,
            column: 20
          },
          end: {
            line: 72,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 72,
            column: 35
          },
          end: {
            line: 72,
            column: 45
          }
        }, {
          start: {
            line: 72,
            column: 48
          },
          end: {
            line: 72,
            column: 56
          }
        }],
        line: 72
      },
      "6": {
        loc: {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 79,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 79,
            column: 11
          }
        }, {
          start: {
            line: 79,
            column: 15
          },
          end: {
            line: 79,
            column: 25
          }
        }],
        line: 79
      },
      "7": {
        loc: {
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 80
      },
      "8": {
        loc: {
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 84,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 84,
            column: 30
          },
          end: {
            line: 84,
            column: 50
          }
        }, {
          start: {
            line: 84,
            column: 53
          },
          end: {
            line: 84,
            column: 70
          }
        }],
        line: 84
      },
      "9": {
        loc: {
          start: {
            line: 99,
            column: 8
          },
          end: {
            line: 115,
            column: 21
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 100,
            column: 12
          },
          end: {
            line: 114,
            column: 13
          }
        }, {
          start: {
            line: 115,
            column: 12
          },
          end: {
            line: 115,
            column: 21
          }
        }],
        line: 99
      },
      "10": {
        loc: {
          start: {
            line: 102,
            column: 14
          },
          end: {
            line: 113,
            column: 15
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 102,
            column: 14
          },
          end: {
            line: 113,
            column: 15
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 102
      },
      "11": {
        loc: {
          start: {
            line: 103,
            column: 16
          },
          end: {
            line: 105,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 103,
            column: 16
          },
          end: {
            line: 103,
            column: 38
          }
        }, {
          start: {
            line: 104,
            column: 16
          },
          end: {
            line: 104,
            column: 38
          }
        }, {
          start: {
            line: 105,
            column: 16
          },
          end: {
            line: 105,
            column: 50
          }
        }],
        line: 103
      },
      "12": {
        loc: {
          start: {
            line: 121,
            column: 19
          },
          end: {
            line: 121,
            column: 53
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 121,
            column: 30
          },
          end: {
            line: 121,
            column: 39
          }
        }, {
          start: {
            line: 121,
            column: 42
          },
          end: {
            line: 121,
            column: 53
          }
        }],
        line: 121
      },
      "13": {
        loc: {
          start: {
            line: 141,
            column: 17
          },
          end: {
            line: 141,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 141,
            column: 36
          },
          end: {
            line: 141,
            column: 47
          }
        }, {
          start: {
            line: 141,
            column: 50
          },
          end: {
            line: 141,
            column: 64
          }
        }],
        line: 141
      },
      "14": {
        loc: {
          start: {
            line: 147,
            column: 24
          },
          end: {
            line: 147,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 147,
            column: 39
          },
          end: {
            line: 147,
            column: 43
          }
        }, {
          start: {
            line: 147,
            column: 46
          },
          end: {
            line: 147,
            column: 79
          }
        }],
        line: 147
      },
      "15": {
        loc: {
          start: {
            line: 161,
            column: 51
          },
          end: {
            line: 161,
            column: 88
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 161,
            column: 62
          },
          end: {
            line: 161,
            column: 64
          }
        }, {
          start: {
            line: 161,
            column: 67
          },
          end: {
            line: 161,
            column: 88
          }
        }],
        line: 161
      },
      "16": {
        loc: {
          start: {
            line: 163,
            column: 11
          },
          end: {
            line: 167,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 163,
            column: 11
          },
          end: {
            line: 163,
            column: 19
          }
        }, {
          start: {
            line: 164,
            column: 12
          },
          end: {
            line: 166,
            column: 19
          }
        }],
        line: 163
      },
      "17": {
        loc: {
          start: {
            line: 164,
            column: 25
          },
          end: {
            line: 164,
            column: 85
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 164,
            column: 36
          },
          end: {
            line: 164,
            column: 63
          }
        }, {
          start: {
            line: 164,
            column: 66
          },
          end: {
            line: 164,
            column: 85
          }
        }],
        line: 164
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "dab72b5b3a5c5d4ef080aab4e75930f9173f8ae0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2ej087gpzc = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2ej087gpzc();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// Single checkbox & single radio are combined here since they have similar styling.
cov_2ej087gpzc().s[0]++;
var CheckboxOrRadio = function CheckboxOrRadio(_ref) {
  var additionalContainerChildren = _ref.additionalContainerChildren,
    analyticsName = _ref.analyticsName,
    checked = _ref.checked,
    disabled = _ref.disabled,
    errorMessage = _ref.errorMessage,
    hasContainer = _ref.hasContainer,
    label = _ref.label,
    name = _ref.name,
    subtitle = _ref.subtitle,
    type = _ref.type,
    value = _ref.value,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_2ej087gpzc().f[0]++;
  var inputRef = (cov_2ej087gpzc().s[1]++, (0, _react.useRef)(null));
  var _ref2 = (cov_2ej087gpzc().s[2]++, (0, _theme.useTheme)()),
    colors = _ref2.colors;
  var radioStyles = (cov_2ej087gpzc().s[3]++, (0, _utils.useStyleConfig)('Radio', {}));
  var checkboxStyles = (cov_2ej087gpzc().s[4]++, (0, _utils.useStyleConfig)('Checkbox', {}));
  var formStyles = (cov_2ej087gpzc().s[5]++, (0, _utils.useMultiStyleConfig)('FormElements', {}));
  var containerStyles = (cov_2ej087gpzc().s[6]++, hasContainer ? (cov_2ej087gpzc().b[0][0]++, errorMessage !== undefined ? (cov_2ej087gpzc().b[1][0]++, formStyles.errorContainer) : (cov_2ej087gpzc().b[1][1]++, disabled ? (cov_2ej087gpzc().b[2][0]++, formStyles.disabledContainer) : (cov_2ej087gpzc().b[2][1]++, formStyles.hasContainer))) : (cov_2ej087gpzc().b[0][1]++, formStyles.noContainer));
  var labelStyles = (cov_2ej087gpzc().s[7]++, disabled ? (cov_2ej087gpzc().b[3][0]++, _objectSpread({
    fontWeight: hasContainer ? (cov_2ej087gpzc().b[4][0]++, 'semibold') : (cov_2ej087gpzc().b[4][1]++, 'normal')
  }, formStyles.disabledLabel)) : (cov_2ej087gpzc().b[3][1]++, _objectSpread({
    fontWeight: hasContainer ? (cov_2ej087gpzc().b[5][0]++, 'semibold') : (cov_2ej087gpzc().b[5][1]++, 'normal')
  }, formStyles.label)));
  var _ref3 = (cov_2ej087gpzc().s[8]++, (0, _useObservabilitySafe.useObservabilitySafe)()),
    trackJourneyEvent = _ref3.trackJourneyEvent;
  cov_2ej087gpzc().s[9]++;
  var handleClick = function handleClick(e) {
    cov_2ej087gpzc().f[1]++;
    cov_2ej087gpzc().s[10]++;
    (cov_2ej087gpzc().b[6][0]++, onClick) && (cov_2ej087gpzc().b[6][1]++, onClick(e));
    cov_2ej087gpzc().s[11]++;
    if (analyticsName) {
      cov_2ej087gpzc().b[7][0]++;
      var data = (cov_2ej087gpzc().s[12]++, {
        targetName: analyticsName,
        optionName: value
      });
      cov_2ej087gpzc().s[13]++;
      trackJourneyEvent('platform', type === 'checkbox' ? (cov_2ej087gpzc().b[8][0]++, 'checkboxClickEvent') : (cov_2ej087gpzc().b[8][1]++, 'radioClickEvent'), data);
    } else {
      cov_2ej087gpzc().b[7][1]++;
    }
  };
  cov_2ej087gpzc().s[14]++;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    _react["default"].createElement(_index.Flex, {
      "data-testid": "".concat(value, "-button"),
      flexDirection: "column"
      // this handles the container styling
      ,
      __css: containerStyles
      // forward clicks on the container to the input element
      ,
      onClick: hasContainer ? (cov_2ej087gpzc().b[9][0]++, function (event) {
        cov_2ej087gpzc().f[2]++;
        var el = (cov_2ej087gpzc().s[15]++, event.target);
        cov_2ej087gpzc().s[16]++;
        if ((cov_2ej087gpzc().b[11][0]++, el.tagName !== 'INPUT') && (cov_2ej087gpzc().b[11][1]++, el.tagName !== 'LABEL') && (cov_2ej087gpzc().b[11][2]++, !el.matches('label ' + el.tagName))) {
          cov_2ej087gpzc().b[10][0]++;
          cov_2ej087gpzc().s[17]++;
          // If the user does not click on the input, label, or an
          // element inside label and we are using hasContainer then
          // we need to manually trigger the onclick
          // (since they clicked somewhere in the container but not on
          // the input/label)
          inputRef.current.click(event);
        } else {
          cov_2ej087gpzc().b[10][1]++;
        }
      }) : (cov_2ej087gpzc().b[9][1]++, undefined)
    }, /*#__PURE__*/_react["default"].createElement(_index.Flex, {
      position: "relative",
      flexDirection: "column"
    }, /*#__PURE__*/_react["default"].createElement(_index.InputBase, _extends({
      ref: inputRef,
      onClick: disabled ? (cov_2ej087gpzc().b[12][0]++, undefined) : (cov_2ej087gpzc().b[12][1]++, handleClick),
      type: type
      // adding a role exposes the checkbox or radio's assistive technology
      // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/checkbox_role
      ,
      role: type
      // htmlFor and id values associate the label with its form control
      ,
      id: "".concat(name, "-").concat(value)
      // group is identified by giving each of the radio buttons/checkboxes in the group the same name
      // not required if you're just using a single radio or checkbox
      ,
      name: name
      // The value attribute is a DOMString containing the radio button's value
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/radio
      ,
      value: value
      // aria-checked indicates if the current state of checkbox/radio is checked for screen-readers
      // https://developer.mozilla.org/en-US/docs/web/Accessibility/ARIA/Attributes/aria-checked
      ,
      "aria-checked": checked
      // aria-disabled indicates if the current state of checkbox/radio is disabled for screen-readers
      // https://developer.mozilla.org/en-US/docs/web/Accessibility/ARIA/Attributes/aria-disabled
      ,
      "aria-disabled": disabled
      // conditional for radio button / checkbox styling
      ,
      __css: type === 'radio' ? (cov_2ej087gpzc().b[13][0]++, radioStyles) : (cov_2ej087gpzc().b[13][1]++, checkboxStyles)
      // Focus styling provides styling if the element itself has focus. https://developer.mozilla.org/en-US/docs/Web/CSS/:focus
      // This only adds focus styling to the radio button when there is no container per figma design
      ,
      _focus: {
        '& + label': {
          _before: {
            border: hasContainer ? (cov_2ej087gpzc().b[14][0]++, null) : (cov_2ej087gpzc().b[14][1]++, "2px solid ".concat(colors.neutrals100))
          }
        }
      },
      checked: checked,
      disabled: disabled
    }, props)), /*#__PURE__*/_react["default"].createElement(_Label["default"], {
      htmlFor: "".concat(name, "-").concat(value),
      __css: disabled ? (cov_2ej087gpzc().b[15][0]++, {}) : (cov_2ej087gpzc().b[15][1]++, {
        cursor: 'pointer'
      })
    }, /*#__PURE__*/_react["default"].createElement(_index.Box, {
      __css: labelStyles
    }, label), (cov_2ej087gpzc().b[16][0]++, subtitle) && (cov_2ej087gpzc().b[16][1]++, /*#__PURE__*/_react["default"].createElement(_index.Text, {
      __css: disabled ? (cov_2ej087gpzc().b[17][0]++, formStyles.disabledSubtitle) : (cov_2ej087gpzc().b[17][1]++, formStyles.subtitle)
    }, subtitle)))), additionalContainerChildren)
  );
};
cov_2ej087gpzc().s[18]++;
var Checkbox = exports.Checkbox = function Checkbox(props) {
  cov_2ej087gpzc().f[3]++;
  cov_2ej087gpzc().s[19]++;
  return /*#__PURE__*/_react["default"].createElement(CheckboxOrRadio, _extends({
    type: "checkbox"
  }, props));
};
cov_2ej087gpzc().s[20]++;
var Radio = exports.Radio = function Radio(props) {
  cov_2ej087gpzc().f[4]++;
  cov_2ej087gpzc().s[21]++;
  return /*#__PURE__*/_react["default"].createElement(CheckboxOrRadio, _extends({
    type: "radio"
  }, props));
};